import React from "react";
import styled from "styled-components";

const News = styled.div`
    background: ${({content}) => content.newsflash.bgColor};
    color: ${({content}) => content.newsflash.textColor};
    display: flex;
    padding: 15px;
    justify-content: flex-start;        
`;

export default function Newsflash({content}) {

    if (!content.newsflash.enabled) {
        return ("");
    }

    return(
        <News content={content}>
            {content.newsflash.text}
        </News>
    )
}